<template>
  <el-dialog
    :visible.sync="visible"
    width="420px"
    :close-on-click-modal="false"
    append-to-body
    @closed="handleClosed"
  >
    <div class="wx-bind-dialog__header">
      <h3 class="wx-bind-dialog__title">绑定微信登录</h3>
      <p class="wx-bind-dialog__tip">请员工微信扫码绑定账号，后续可微信快捷登录</p>
    </div>
    <!-- v-if 保证每次打开重新出码、关闭即销毁清理定时器与监听 -->
    <wx-scan-login
      v-if="visible"
      ref="wxScan"
      scene="bind"
      :fast-login="false"
      @code="onCode"
      @error="onError"
    />
    <p class="wx-bind-dialog__account">
      {{ staff.userName }}<template v-if="staff.userAccount"> ({{ staff.userAccount }})</template>
    </p>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from '@qs/ui'
import { bindUserByCode } from '@/api/wechatLogin'
import WxScanLogin from '@/components/WxScanLogin'

const emit = defineEmits(['refresh'])

const wxScan = ref(null)
const visible = ref(false)
const staff = ref({})
// 绑定请求进行中，避免同一 code 重复提交
let binding = false

const retry = () => {
  binding = false
  if (wxScan.value) wxScan.value.refresh()
}

const onCode = ({ code, state }) => {
  if (binding) return
  binding = true
  bindUserByCode({ userId: staff.value.id, code, state })
    .then((res) => {
      // T16：code===1 即判绑定成功，不依赖出参内容
      if (res && res.code === 1) {
        Message.success('绑定成功')
        visible.value = false
        emit('refresh')
      } else {
        // code!==1：msg 已由 request 弹出，重新出码允许再扫
        retry()
      }
    })
    .catch(() => {
      retry()
    })
}

const onError = () => {
  // 出码失败由 WxScanLogin 内部展示重试入口
}

const handleClosed = () => {
  staff.value = {}
  binding = false
}

// 供父组件通过 ref 调用
const open = (row) => {
  staff.value = row || {}
  binding = false
  visible.value = true
}

defineExpose({ open })
</script>

<style lang="scss" scoped>
.wx-bind-dialog__header {
  margin-bottom: 12px;
  text-align: center;
}
.wx-bind-dialog__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a2233;
}
.wx-bind-dialog__tip {
  margin: 8px 0 0;
  font-size: 13px;
  color: #909399;
}
.wx-bind-dialog__account {
  margin: 12px 0 0;
  font-size: 14px;
  color: #303133;
  text-align: center;
}
</style>
